export const SICKNESS_KIND_GET_REQUEST = 'SICKNESS_KIND_GET_REQUEST';
export const SICKNESS_KIND_GET_SUCCESS = 'SICKNESS_KIND_GET_SUCCESS';
export const SICKNESS_KIND_GET_ERROR = 'SICKNESS_KIND_GET_ERROR';
export const SICKNESS_KIND_GET_BY_KEY_REQUEST = 'SICKNESS_KIND_GET_BY_KEY_REQUEST';
export const SICKNESS_KIND_GET_BY_KEY_SUCCESS = 'SICKNESS_KIND_GET_BY_KEY_SUCCESS';
export const SICKNESS_KIND_GET_BY_KEY_ERROR = 'SICKNESS_KIND_GET_BY_KEY_ERROR';
export const SICKNESS_KIND_ADD_REQUEST = 'SICKNESS_KIND_ADD_REQUEST';
export const SICKNESS_KIND_ADD_SUCCESS = 'SICKNESS_KIND_ADD_SUCCESS';
export const SICKNESS_KIND_ADD_ERROR = 'SICKNESS_KIND_ADD_ERROR';
export const SICKNESS_KIND_EDIT_REQUEST = 'SICKNESS_KIND_EDIT_REQUEST';
export const SICKNESS_KIND_EDIT_SUCCESS = 'SICKNESS_KIND_EDIT_SUCCESS';
export const SICKNESS_KIND_EDIT_ERROR = 'SICKNESS_KIND_EDIT_ERROR';
export const SICKNESS_KIND_DELETE_REQUEST = 'SICKNESS_KIND_DELETE_REQUEST';
export const SICKNESS_KIND_DELETE_SUCCESS = 'SICKNESS_KIND_DELETE_SUCCESS';
export const SICKNESS_KIND_DELETE_ERROR = 'SICKNESS_KIND_DELETE_ERROR';
